import Vue from 'vue'
import Murmur from '@icij/murmur'
Vue.use(Murmur)
Murmur.config.set('project.name', 'Pandora Papers')
Murmur.config.set('app.name', 'Real Estate')
Murmur.config.set('app.home', 'https://www.icij.org/investigations/pandora-papers/')

